module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('video-player', {
    attrs: {
      "options": _vm.playerOptions
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c6ba9d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/feedback/Feedback.vue
// module id = 1975
// module chunks = 2